import { Tab } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'

const StyledTab = withStyles({
  labelIcon: {
    fontWeight: 700,
    fontSize: 14,
  },
})(Tab)

export default StyledTab
